import { HttpClient } from '@wix/http-client';

const baseURL = window.location.origin;

export const httpClient = new HttpClient({ baseURL });

export * from '@wix/http-client';
